






























































































import { API_REVENUE_CATEGORY_LIST } from "@/configs/Apis";
import formatters from "@/utils/ColumnFormater";
import {
  hasPermission,
  isEmptyOrWhiteSpace,
  showConfirm,
  showSuccess,
  showError,
  showWarning,
} from "@/utils/Common";
import RevenueCategoryForm from "@/views/setting/subviews/RevenueCategoryForm.vue";
import { TableColumn } from "element-ui/types/table-column";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    RevenueCategoryForm,
  },
})
export default class RevenueCategoryList extends Vue {
  queryData: any = { name: "" };

  addRevenueCategoryFormDialogVisible = false;
  revenueCategoryItem: any = { id: 0 };

  hasSelectedItems = false;

  queryStr = "";
  loadData = false;

  showSearch = false;

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_REVENUE_CATEGORY_LIST;
  }

  get colFormatters() {
    return formatters;
  }

  hasPerm(checkedPerm: string) {
    return hasPermission(this.$store.getters["user/user"] || {}, checkedPerm);
  }

  createTableColumns() {
    const columns: Array<TableColumnOption> = [
      { prop: "name", display: "名称", width: 200 },
      { prop: "remark", display: "备注" }
    ];
    this.$store.dispatch("revenue/setColumns", columns);
  }

  reloadData() {
    this.searchData();
  }

  onModuleRegistered() {
    this.$nextTick()
      .then(() => this.createTableColumns())
      .then(() => {
        this.onSearchConditionChange();
      });
  }

  onTextKeyup() {
    ((this.$refs.searchBtn as Vue).$el as HTMLInputElement).focus();
  }

  onSearchConditionChange() {
    const params: { [key: string]: any } = {};
    if (!isEmptyOrWhiteSpace(this.queryData.name)) {
      params.name = this.queryData.name;
    }
    const paramsStr = JSON.stringify(params);
    if (paramsStr === "{}" && this.queryStr.trim() === "") {
      this.queryStr = "{}";
      return;
    }
    if (paramsStr !== this.queryStr.trim()) {
      this.queryStr = JSON.stringify(params);
    }
  }

  searchData() {
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  addRevenueCategory() {
    this.revenueCategoryItem = { id: 0, name: "" };
    this.addRevenueCategoryFormDialogVisible = true;
  }

  addRevenueCategorySuccess() {
    this.addRevenueCategoryFormDialogVisible = false;
    this.reloadData();
    this.revenueCategoryItem = { id: 0, name: "" };
  }

  editRevenueCategory() {
    const selectedRows = (this.$refs.revenuecategorygrid as any).getSelectedDataRows();
    if (!selectedRows || selectedRows.length === 0) {
      showWarning("请选择一个分类");
      return;
    }
    this.revenueCategoryItem = JSON.parse(JSON.stringify(selectedRows[0]));
    this.addRevenueCategoryFormDialogVisible = true;
  }

  onSelectionChanged(selectedRows: any[]) {
    this.hasSelectedItems = selectedRows.length > 0;
  }

  onRowClick(command: string, data: any, event: MouseEvent) {
    //
  }

  onColumnResize(newWidth: number, column: TableColumn) {
    this.$store.dispatch("revenue/setColumnWidth", {
      listName: "revenueCategory",
      column: column.property,
      newWidth,
    });
  }

  onTableDataLoaded() {
    //
  }

  openSearchPanel() {
    this.showSearch = !this.showSearch;
  }

  batchDeleteData(cmd: string) {
    let params: any = {};
    let msg = "当前列表";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.revenuecategorygrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      params.selectedIds = selectedRows;
      msg = `${selectedRows.length} 条数据`;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    showConfirm(`是否确认删除 ${msg}？`).then(() => {
      this.$store
        .dispatch("revenue/deleteRevenueCategory", params)
        .then(() => {
          showSuccess("删除成功");
          this.reloadData();
        })
        .catch(({ message }) => showError(message));
    });
  }
}
